import React from 'react';
import { PlayingCard } from './PlayingCard';
import { BlackjackVerifyForm } from './BlackjackVerifyForm';
import { BetReceiptShell } from '../keno/BetReceiptShell';
import { BlackjackSideResults } from './BlackjackSideResults';
import { PublicReceiptFairness } from '../keno/PublicReceiptFairness';

const ReceiptHand = ({ cards, total, label, outcome, id }) => (
  <section className={`bet-receipt-hand outcome-${outcome}`} data-testid={id}>
    <h3 data-testid={`${id}-label`}>{label}</h3>
    <span className="bj-hand-total" data-testid={`${id}-total`}>{total}</span>
    <div className="bet-receipt-cards" data-testid={`${id}-cards`}>
      {cards.map((card, index) => <PlayingCard key={index} value={card} instant outcome={outcome} testid={`${id}-card-${index}`} />)}
    </div>
  </section>
);
export const BlackjackBetDetails = ({ round, game, onClose, onCloseAutoFocus, onPlay }) => {
  const anyWin = round.hands.some((hand) => hand.payout_minor > hand.bet_minor), anyLoss = round.hands.some((hand) => hand.payout_minor < hand.bet_minor);
  const dealerOutcome = anyWin && !anyLoss ? 'loss' : anyLoss && !anyWin ? 'win' : 'push';
  return <BetReceiptShell type="blackjack" round={round} playerGhost={game?.wallet?.ghost} onClose={onClose} onCloseAutoFocus={onCloseAutoFocus} onPlay={onPlay} fairness={round.public_view ? <PublicReceiptFairness round={round} /> : <BlackjackVerifyForm game={{ ...game, round }} />}>
    <ReceiptHand cards={round.dealer_cards} total={round.dealer_total} label="Dealer" outcome={dealerOutcome} id="blackjack-receipt-dealer" />
    <div className={round.hands.length > 1 ? 'bet-receipt-split' : ''}>{round.hands.map((hand, index) => <ReceiptHand key={index} cards={hand.cards} total={hand.total} label={round.hands.length > 1 ? `Player · Hand ${index + 1}` : 'Player'} outcome={hand.payout_minor > hand.bet_minor ? 'win' : hand.payout_minor < hand.bet_minor ? 'loss' : 'push'} id={`blackjack-receipt-hand-${index}`} />)}</div>
    <BlackjackSideResults round={round} receipt />
  </BetReceiptShell>;
};